var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initials.length > 0)?_c('Avatar',{style:(_vm.styles)},[_vm._v(_vm._s(_vm.initials))]):_c('Avatar',{style:(_vm.styles),attrs:{"icon":"ios-person"}})}
var staticRenderFns = []

export { render, staticRenderFns }